// extracted by mini-css-extract-plugin
export default {"container":"content-loader__container___fPnXK","line":"content-loader__line___mlSJP","loading":"content-loader__loading___X01Uv","text":"content-loader__text___UNRMB"};